export default __webpack_public_path__ + "img/download-report.efa75b15.svg";